export default __webpack_public_path__ + "assets/poster.38de2ecc5f4c3b552ee9b3be385d30df.jpg";